// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__7nwJJ","load8":"SmallLoader_load8__QVURq"};